import { render } from "./CancelTicket.vue?vue&type=template&id=002a8f2a"
import script from "./CancelTicket.vue?vue&type=script&lang=js"
export * from "./CancelTicket.vue?vue&type=script&lang=js"

import exportComponent from "/Users/klous/Documents/beye/src/ui/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__